import { css } from '@emotion/react';

import { hexToRgbaString, white } from 'styles/global_defaults/colors';
import { doubleSpacing } from 'styles/global_defaults/scaffolding';

/** Shared circular icon-button styles for the lecture page edit-mode top panel.
 * Single source of truth so the hover/focus-visible treatment stays in sync across
 * every icon in the bar (top-panel-action-button, lecture-page-top-panel,
 * add-new-lesson-button, more-menu-action-button). */
const editMenuIconStyles = (hoverBackgroundColor?: string, hoverIconColor?: string) => css`
  width: ${doubleSpacing}px;
  height: ${doubleSpacing}px;
  border-radius: 50%;

  &:hover, &:focus-visible {
    background-color: ${hoverBackgroundColor ?? hexToRgbaString(white, 0.4)};
    cursor: pointer;

    ${hoverIconColor && css`
      i {
        color: ${hoverIconColor} !important;
      }
    `}
  }
`;

export default editMenuIconStyles;
